/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

export default {
    init() {
        // JavaScript to be fired on the bio page
        if ($(window).outerWidth() > 768) {
            // Timeline using ScrollMagic
            var controller = new ScrollMagic.Controller(); // init controller
            var duration = $('#items').outerWidth();
            var wipeAnimation = new TimelineMax().fromTo(
                items,
                1,
                { x: '0%' },
                { x: '-92%' }
            ); // define movement of panels

            // create scene to pin and link animation
            new ScrollMagic.Scene({
                triggerElement: '#timeline',
                triggerHook: 'onLeave',
                duration: duration,
            })
                .setPin('#timeline')
                .setTween(wipeAnimation)
                .addTo(controller);
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/bio.js